import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { PostWithCommentsAndLikesFragmentDoc } from '../../../fragments/__generated__/postData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserPostsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filters?: Types.InputMaybe<Types.PostFilterOptions>;
}>;


export type GetCurrentUserPostsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email?: string | null, hasCreatedPosts: boolean, posts?: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', cursor: string, node: { __typename?: 'Post', id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, likes?: Array<{ __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }, likes?: Array<{ __typename?: 'CommentLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null }>, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };


export const GetCurrentUserPostsDocument = gql`
    query GetCurrentUserPosts($first: Int, $after: String, $filters: PostFilterOptions) {
  currentUser {
    id
    email
    hasCreatedPosts
    posts(first: $first, after: $after, filters: $filters) {
      edges {
        cursor
        node {
          ...PostWithCommentsAndLikes
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${PostWithCommentsAndLikesFragmentDoc}`;

/**
 * __useGetCurrentUserPostsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPostsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCurrentUserPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>(GetCurrentUserPostsDocument, options);
      }
export function useGetCurrentUserPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>(GetCurrentUserPostsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>;
export function useGetCurrentUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserPostsQuery | undefined, GetCurrentUserPostsQueryVariables>;
export function useGetCurrentUserPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>(GetCurrentUserPostsDocument, options);
        }
export type GetCurrentUserPostsQueryHookResult = ReturnType<typeof useGetCurrentUserPostsQuery>;
export type GetCurrentUserPostsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserPostsLazyQuery>;
export type GetCurrentUserPostsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserPostsSuspenseQuery>;
export type GetCurrentUserPostsQueryResult = Apollo.QueryResult<GetCurrentUserPostsQuery, GetCurrentUserPostsQueryVariables>;